import { useEffect } from 'react';
import FullAudioPlayer from './components/FullAudioPlayer';

const audios = [
  {
    title: 'Cura da Criança Interior',
    url: 'https://terapia.nxhost.com.br/curainterior.mp3',
    duration: '28:00',
    image: 'https://readdy.ai/api/search-image?query=Soft%20warm%20golden%20light%20emanating%20from%20a%20gentle%20abstract%20silhouette%20of%20a%20child%20sitting%20in%20meditation%2C%20ethereal%20glow%20with%20amber%20and%20cream%20tones%2C%20minimalist%20spiritual%20art%20with%20no%20text%2C%20calming%20healing%20energy%2C%20warm%20neutral%20background&width=400&height=400&seq=audio-cura-interior-thank&orientation=squarish',
    description: 'Reconecte-se com a criança interior através de frequências binaurais que promovem cura emocional profunda e autocompaixão.',
  },
  {
    title: 'Limpeza de Relacionamentos Passados',
    url: 'https://terapia.nxhost.com.br/sessaorelacionamento.mp3',
    duration: '46:00',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20flowing%20ribbons%20of%20light%20breaking%20free%20and%20dissolving%20into%20warm%20golden%20particles%2C%20soft%20ethereal%20atmosphere%20with%20rose%20and%20amber%20tones%2C%20spiritual%20liberation%20concept%20art%2C%20no%20text%20no%20people%2C%20warm%20neutral%20background&width=400&height=400&seq=audio-relacionamento-thank&orientation=squarish',
    description: 'Liberte-se de laços emocionais com frequências que auxiliam na limpeza energética de relacionamentos antigos.',
  },
  {
    title: 'Prosperidade e Abundância',
    url: 'https://terapia.nxhost.com.br/sessaoriqueza.mp3',
    duration: '47:00',
    image: 'https://readdy.ai/api/search-image?query=Radiant%20golden%20abundance%20energy%20flowing%20upward%20like%20sunlight%20through%20crystals%2C%20warm%20honey%20and%20amber%20light%20particles%20shimmering%20in%20space%2C%20prosperity%20and%20wealth%20energy%20visualization%2C%20no%20text%20no%20people%2C%20minimalist%20spiritual%20art&width=400&height=400&seq=audio-riqueza-thank&orientation=squarish',
    description: 'Eleve sua vibração de prosperidade com frequências projetadas para atrair abundância e abrir caminhos financeiros.',
  },
];

const tips = [
  {
    icon: 'ri-headphone-line',
    title: 'Use fones de ouvido',
    desc: 'Para aproveitar as frequências binaurais, use fones de ouvido estéreo.',
  },
  {
    icon: 'ri-moon-line',
    title: 'Ambiente tranquilo',
    desc: 'Escolha um local silencioso, deitado ou sentado confortavelmente.',
  },
  {
    icon: 'ri-eye-close-line',
    title: 'Olhos fechados',
    desc: 'Feche os olhos para intensificar a experiência e relaxamento.',
  },
  {
    icon: 'ri-time-line',
    title: 'Repetição diária',
    desc: 'Ouça o mesmo áudio por 21 dias seguidos para resultados.',
  },
];

export default function ThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Header simplificado */}
      <header className="bg-background-50/95 backdrop-blur-md border-b border-background-200/70 sticky top-0 z-50">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-18">
            <a
              href="/"
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500">
                <i className="ri-sound-module-line text-background-50 text-lg" />
              </div>
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-900">
                Áudio Cura
              </span>
            </a>
            <a
              href="/"
              className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Voltar ao site
            </a>
          </div>
        </div>
      </header>

      <main>
        {/* Hero de confirmação */}
        <section className="relative w-full bg-gradient-to-b from-accent-50 via-background-50 to-background-50 py-12 md:py-20 overflow-hidden">
          <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-accent-200/20 blur-3xl" />
          <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full bg-primary-200/20 blur-3xl" />
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center relative z-10">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 shadow-lg shadow-primary-500/20">
              <i className="ri-check-double-line text-background-50 text-3xl" />
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border mb-6 bg-primary-100 border-primary-300">
              <i className="ri-shield-check-line text-primary-600 text-sm" />
              <span className="text-sm font-bold whitespace-nowrap text-primary-700">Compra confirmada</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4 leading-tight">
              Bem-vindo à Área do Aluno!
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-6 leading-relaxed">
              Parabéns! Seu acesso aos 3 áudios de cura foi liberado. Eles ficam disponíveis por 1 ano.
              Coloque seus fones de ouvido, relaxe e aproveite cada frequência.
            </p>
            <div className="flex items-center justify-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-calendar-check-line text-accent-500" />
                Acesso por 1 ano
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-headphone-line text-accent-500" />
                Ouça quantas vezes quiser
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-download-cloud-line text-accent-500" />
                Online e offline
              </span>
            </div>
          </div>
        </section>

        {/* Dicas de como ouvir */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">
              Como aproveitar ao máximo
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {tips.map((tip, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 text-center shadow-sm"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${tip.icon} text-accent-600 text-lg`} />
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1">{tip.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{tip.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Áudios completos */}
        <section className="w-full py-12 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border mb-4 bg-accent-100 border-accent-300">
                <i className="ri-music-2-line text-accent-600 text-sm" />
                <span className="text-sm font-bold whitespace-nowrap text-accent-700">Seus áudios de cura</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                Clique para começar a ouvir
              </h2>
              <p className="text-sm text-foreground-600 max-w-md mx-auto">
                Todos os 3 áudios estão prontos. Use fones de ouvido e escolha um ambiente tranquilo.
              </p>
            </div>

            <div className="space-y-6">
              {audios.map((audio, i) => (
                <div key={i}>
                  <div className="mb-2">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900">
                      {i + 1}. {audio.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{audio.description}</p>
                  </div>
                  <FullAudioPlayer
                    audioUrl={audio.url}
                    title={audio.title}
                    duration={audio.duration}
                    image={audio.image}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="w-full py-12 md:py-16 bg-gradient-to-br from-primary-50 via-accent-50/70 to-primary-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
            <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary-500/20">
              <i className="ri-heart-3-line text-background-50 text-2xl" />
            </div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
              Transformação começa agora
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
              Dedique pelo menos 15 minutos por dia para ouvir seus áudios. A constância é a chave para
              a transformação energética e emocional.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://wa.me/5554996542326"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full font-semibold text-sm transition-all focus-visible:outline-2 focus-visible:outline-accent-500 bg-accent-500 text-background-50 hover:bg-accent-600 shadow-lg shadow-accent-500/20"
              >
                <i className="ri-whatsapp-line" />
                Dúvidas? Fale conosco
              </a>
              <a
                href="mailto:vendas@nxhost.com.br"
                className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full font-semibold text-sm transition-all border border-background-300 text-foreground-700 hover:bg-background-100"
              >
                <i className="ri-mail-line" />
                Enviar email
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-background-900 text-background-200" role="contentinfo">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-accent-400">
                <i className="ri-sound-module-line text-background-50 text-lg" />
              </div>
              <span className="font-heading text-lg font-bold text-background-50">Áudio Cura</span>
            </div>
            <p className="text-xs text-background-500 text-center md:text-right">
              © 2026 Áudio Cura. Área do Aluno — Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}